import React, { Component, createContext } from 'react';
import ReactGA from 'react-ga';

export const GlobalContext = createContext();

class GlobalContextProvider extends Component {
	state = {
		config: {},
		refsets: {},
		refsetsFiltered: [{ code: '', display: '' },],
		refSetQuery: "",
		refsetMembers: [{ code: '', display: '' },],
		refsetCount: 0,
		refSetFilterCount: 0,
		refsetsLoaded: false,
		iconurl: '',
		server: '',
		analytics: '',
		analyticsInitialised: false,
		tagSystem: '',
		working: false
	};

	async componentDidMount() {
		this.getData();

	}

	getRefSet = async (x) => {

		//}/ValueSet/$expand?url=http://snomed.info/sct?fhir_vs=refset/723264001&count=10&filter=myot
		const response = await fetch(
			`https://r4.ontoserver.csiro.au/fhir/ValueSet/$expand?url=http://snomed.info/sct?fhir_vs=refset/${x}&count=1000`
		);
		const jsonData = await response.json();
		//console.log(jsonData);
		this.setState({ refsetMembers: jsonData.expansion.contains });
	};

	getData = async () => {
		var hostname = window.location.hostname;

		if (hostname === 'localhost') hostname = 'termcat.netlify.app';

		var serverUrl = `https://clarotech-termcat.s3.amazonaws.com/${hostname}/servers.json`;

		fetch(serverUrl)
			.then((response) => response.json())
			.then((data) => {
				this.setState({ config: data });
				this.setState({ analytics: data.analytics });
				this.setState({ tagSystem: data.tagSystem });
				this.setState({ server: data.servers[0].url }, this.getRefSets);
				this.setState({
					iconurl: `https://clarotech-termcat.s3.amazonaws.com/${hostname}/${data.logo}`,
				});
				document.title = data.name;
				this.activeServer = data.servers[0].url;
			});
	};

	initAnalytics = () => {
		if (this.state.analytics !== '' && this.state.analyticsInitialised === false) {
			ReactGA.initialize(this.state.analytics, { siteSpeedSampleRate: 100 });
			this.setState({ analyticsInitialised: true });
		}
	};

	logPageAnalytics = () => {
		if (this.state.analytics !== '') {
			ReactGA.pageview(window.location.pathname + window.location.search);
		}
	};

	logEventAnalytics = (eventCategory, eventAction, eventLabel) => {
		if (this.state.analytics !== '') {
			ReactGA.event(
				{
					category: eventCategory,
					action: eventAction,
					label: eventLabel
				}
			);
		}
	};

	setRefSetQuery = (query) => {
		this.setState({ refSetQuery: query });

		const empty = [
			{ code: '', display: '' },
		];

		var newList

		if (this.state.refsets.resourceType) {
			newList = this.state.refsets.expansion.contains.map((x) => this.createData(x));
			var sorted = newList.sort((a, b) => a.display.localeCompare(b.display));
			var tot = ((query !== "") ? sorted.filter((x) => x.display.toLowerCase().includes(query.toLowerCase())) : sorted);
			this.setState({ refSetFilterCount: tot.length });
			this.setState({ refsetsFiltered: tot });

		} else {
			this.setState({ refSetFilterCount: 0 });
			this.setState({ refsetsFiltered: empty });
		}
	};

	// setRefSetFilterCount = (value) => {
	// 	this.setState({ refSetFilterCount: value });
	// };

	createData(item) {
		const code = item.code;
		const display = item.display;

		return {
			code,
			display
		};
	}

	getRefSets = async () => {
		var serverUrl =
			this.state.server +
			`ValueSet/$expand?url=http://snomed.info/sct?fhir_vs=refset&_format=json`;

		this.state.working = true;
		fetch(serverUrl)
			.then((response) => response.json())
			.then((data) => {
				this.setState({
					refsets: data,
					refsetCount: data.expansion.contains.length,
					refsetsLoaded: true,
				});
				this.setRefSetQuery('');
			});
		this.state.working = false;
	};

	setServer = (name) => {
		this.setState({ server: name });
	};

	render() {
		return (
			<GlobalContext.Provider
				value={{
					...this.state,
					initAnalytics: this.initAnalytics,
					logEventAnalytics: this.logEventAnalytics,
					logPageAnalytics: this.logPageAnalytics,
					getRefSet: this.getRefSet,
					setServer: this.setServer,
					setRefSetQuery: this.setRefSetQuery,
					setRefSetFilterCount: this.setRefSetFilterCount
				}}
			>
				{this.props.children}
			</GlobalContext.Provider>
		);
	}
}

export default GlobalContextProvider;
